import { render, staticRenderFns } from "./formProductServices.vue?vue&type=template&id=9a0dc4aa&scoped=true"
import script from "./formProductServices.vue?vue&type=script&lang=js"
export * from "./formProductServices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a0dc4aa",
  null
  
)

export default component.exports